import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ScreenType } from '../common/enum';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private resizeStreams$ = fromEvent(window, 'resize').pipe(debounceTime(500));
  private destroy$ = new Subject();
  private currentScreen = null;
  public currentScreenWidth = 0;
  public currentMedia$: Subject<ScreenType> = new Subject<ScreenType>();

  get currentMedia(): ScreenType {
    return this.currentScreen;
  }

  websiteDirection$: BehaviorSubject<'ltr' | 'rtl'> = new BehaviorSubject('ltr');

  constructor(private translateService:TranslateService) {
    this.onResize(window.innerWidth);
    this.resizeStreams$.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      this.onResize(event['currentTarget']['innerWidth']);
    });
    this.translateService.currentLang === "ar" ? this.websiteDirection$.next('rtl') : this.websiteDirection$.next('ltr')
  }

  dispose(): void {
    this.destroy$.complete();
  }

  private onResize(width: number) {
    if (width >= 1024) {
      this.currentScreen = ScreenType.desktop;
    } else if (width <= 1024 && width > 600) {
      this.currentScreen = ScreenType.tablet;
    } else if (width <= 600) {
      this.currentScreen = ScreenType.phone;
    }
    this.currentScreenWidth = width;
    this.currentMedia$.next(this.currentScreen);
  }
}
